import uploadicon from "./upload_icon_16px.png";

export const UploadIcon = () => <img src={uploadicon} alt="Upload icon" />;
